import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { styled } from '@mui/material/styles';
import { Paper, Divider, List, ListItem, ListItemText, ListItemIcon, } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AssetDownloadLink from '../../../common/AssetDownloadLink';
import PanelTitle from '../PanelTitle';
const StyledDivider = styled((props) => (
// eslint-disable-next-line react/jsx-props-no-spreading
_jsx(Divider, { ...props })))(({ theme }) => ({
    borderColor: theme.portal.site.lineColor,
    borderBottomWidth: 1,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
}));
const Resources = ({ items, settings: { showTitle, showResources, resourcesCount }, }) => (_jsxs(Paper, { elevation: 0, sx: { display: 'flex', flexDirection: 'column' }, children: [showTitle && _jsx(PanelTitle, { title: "RESOURCES" }), console.log('provided items => ', items), showResources && (_jsx(List, { disablePadding: true, sx: { width: '100%', bgcolor: 'background.paper' }, children: items?.slice(0, resourcesCount).map((item) => (_jsxs(_Fragment, { children: [_jsxs(ListItem, { 
                        // button
                        // component="a"
                        // href={url}
                        disablePadding: true, sx: { px: 2 }, children: [_jsx(ListItemIcon, { sx: { my: 'auto' }, children: _jsx(CloudDownloadIcon, {}) }), _jsx(ListItemText, { primary: (_jsx(AssetDownloadLink, { name: item.name, asset: item.item.asset })), primaryTypographyProps: {
                                    sx: {
                                        color: (theme) => theme.palette.greyCustom[800],
                                        fontSize: (theme) => theme.typography.subtitle1.fontSize,
                                        fontWeight: 'fontWeightBold',
                                    },
                                } })] }, item.id), _jsx(StyledDivider, { component: "li" }, `${item.id}-divider`)] }))) }))] }));
Resources.defaultProps = {
    settings: {
        showTitle: true,
        showResources: true,
        resourcesCount: undefined,
    },
};
Resources.meta = {
    group: 'hidden',
    name: 'Program Resources Tab',
    description: 'Component displays the course combined resources',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.showTitle',
            name: 'Show Title',
            type: 'boolean',
            description: 'Show the title on the Resources panel',
        },
        {
            key: 'settings.showResources',
            name: 'Show Resources',
            type: 'boolean',
            description: 'Show all resources of entire course or program',
        },
        {
            key: 'settings.resourcesCount',
            name: 'Resources count',
            type: 'number',
            description: 'Display limit for resources list.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Resources',
        props: {
            resources: '@course.resources',
            settings: {
                showTitle: true,
                showResources: true,
                resourcesCount: undefined, // show all
            },
        },
    },
};
export default observer(Resources);
//# sourceMappingURL=Resources.js.map